import ZPageNav from './ZPageNav.vue'

export default ZPageNav
